import React from 'react';
import { useMonitoringGoods } from './MonitoringContext';
import { Button } from '@/components/atoms/PcButton';
import ArrowRedUpIcon from '@/assets/icons/V3/arrow/ArrowRedUpIcon.svg?react';
import ArrowBlueDownIcon from '@/assets/icons/V3/arrow/ArrowBlueDownIcon.svg?react';
import EditKeyword from './EditKeyword';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/molecules/DropdownMenu';
import TrashIcon from '@/assets/icons/Monitoring/eva_trash-2-outline.svg?react';
import MoreIcon from '@/assets/icons/Monitoring/MoreIcon.svg?react';
import { usePost, CPLAT_API_ROUTES } from '@/api';
import { useState } from 'react';
import { useToast } from '@/hooks/V3/useToast';
import { useAppSelector } from '@/redux/store';
import { MonitoringGoodsDetail } from '@/types/api';
import { Dialog, DialogTrigger, DialogContent, DialogClose } from '@/components/atoms/Dialog';

type DeleteGoodsBtnProps = {
  handleDelete: () => void;
  isLoading: boolean;
  isMockGoods?: boolean;
};

const DeleteGoodsBtn = ({ handleDelete, isLoading, isMockGoods }: DeleteGoodsBtnProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleDropdownClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDropdownOpen(false);
    setDialogOpen(true);
  };

  const onDelete = () => {
    handleDelete();
    setDialogOpen(false);
  };

  return (
    <>
      <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="h-[34px] w-[34px] p-[7px] shadow-none">
            <MoreIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-[100px]">
          <DropdownMenuItem
            onClick={handleDropdownClick}
            disabled={isLoading}
            className="cursor-pointer gap-[2px] text-gr-700 Body5M14"
          >
            <TrashIcon />
            삭제하기
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent noCloseBtn className="h-[220px] w-[320px] p-[30px]">
          {isMockGoods ? (
            <div className="flex flex-col items-center justify-between gap-8">
              <div className="text-gr-900 Title3S18">예시 상품은 삭제할 수 없습니다</div>
              <DialogClose asChild>
                <Button variant="default" className="h-[44px] w-full">
                  닫기
                </Button>
              </DialogClose>
            </div>
          ) : (
            <div className="flex w-full flex-col gap-[20px]">
              <div className="flex flex-col gap-1">
                <div className="text-gr-900 Title3S18">모니터링 상품 1개를 삭제할게요</div>
                <div className="text-gr-700 Body5M14">
                  상품이 삭제된 기간 동안 <br />
                  해당 상품은 모니터링 진행되지 않아요.
                  <br />
                  그래도 삭제할까요?
                </div>
              </div>
              <div className="flex gap-3">
                <DialogClose asChild>
                  <Button variant="muted" className="h-[44px] flex-1">
                    닫기
                  </Button>
                </DialogClose>
                <Button onClick={onDelete} variant="default" className="h-[44px] flex-1">
                  삭제
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DeleteGoodsBtn;
